enum HTTP_STATUSES {
	FORBIDDEN = 403,
	UNAUTHORIZED = 401,
	SUCCESS = 200,
	SUCCESS_201 = 201,
	PENDING = 202,
	NOT_FOUND = 404,
	BAD_REQUEST = 400,
	INTERNAL_SERVER_ERROR = 500,
	CORS = 102,
}

export default HTTP_STATUSES;
